<template>
    <Modal modalId="fuel-monitor-features-modal" size="modal-md">
        <ModalHeader :title="$t('xWhatAreTheFeatures')" icon="far fa-circle-info colorOrange mr-1"
            :style="{ padding: '4px 12px' }">
            <div class="cols-auto">
                <button type="button" class="btn btn-icon-button btn-icon-button--gray"
                    @click="closeFuelMonitorFeaturesModal()" data-test-hook="CloseModalBtn">
                    <i class="fas fa-times" />
                </button>
            </div>
        </ModalHeader>
        <ModalBody>
            <div class="features">
                <div class="premium">
                    <p class="mb-1">
                        <strong>{{ $t('xFeaturesIncludedInPremium') }}</strong>
                    </p>
                    <div class="feature">
                        <i class="fa-regular fa-gas-pump"></i>
                        <div class="mb-2">
                            <p data-test-hook="fuel-monitor-features-modal-step-1-fuel-monitor-feature-title">
                                <strong>{{ $t('xCurrentFuelLevel') }}</strong>
                            </p>
                            <p class="supporting-text"
                                data-test-hook="premium-enrollment-modal-step-1-fuel-monitor-feature-description">
                                {{ $t('xFuelLevelDescription') }}
                            </p>
                        </div>
                    </div>
                    <div class="feature">
                        <i class="fa-regular fa-chart-line"></i>
                        <div class="mb-2">
                            <p data-test-hook="fuel-monitor-features-modal-step-2-fuel-monitor-feature-title">
                                <strong>{{ $t('xFuelUsageHistory') }}</strong>
                            </p>
                            <p class="supporting-text"
                                data-test-hook="fuel-monitor-features-modal-step-2-fuel-monitor-feature-description">
                                {{ $t('xFuelUsageDescription') }}
                            </p>
                        </div>
                    </div>
                    <div class="feature">
                        <i class="fa-regular fa-warning"></i>
                        <div class="mb-2">
                            <p data-test-hook="fuel-monitor-features-modal-step-3-fuel-monitor-feature-title">
                                <strong>{{ $t('xFuelLevelWarnings') }}</strong>
                            </p>
                            <p class="supporting-text"
                                data-test-hook="fuel-monitor-features-modal-step-3-fuel-monitor-feature-description">
                                {{ $t('xFuelLevelWarningsDescription') }}
                            </p>
                        </div>
                    </div>
                    <div class="feature">
                        <i class="fa-regular fa-battery-full"></i>
                        <div class="mb-2">
                            <p data-test-hook="fuel-monitor-features-modal-step-4-fuel-monitor-feature-title">
                                <strong>{{ $t('xBatteryLevel') }}</strong>
                            </p>
                            <p class="supporting-text"
                                data-test-hook="fuel-monitor-features-modal-step-4-fuel-monitor-feature-description">
                                {{ $t('xBatteryLevelDescription') }}
                            </p>
                        </div>
                    </div>
                    <p> {{ $t('xFuelMonitorsRequireAPlan') }} </p>
                </div>
            </div>
        </ModalBody>
    </Modal>
</template>

<script>
export default {
    methods: {
        closeFuelMonitorFeaturesModal() {
            this.closeModal('fuel-monitor-features-modal')
        }
    }
}
</script>

<style scoped lang="scss">
.features {
    gap: 0.75em;
    display: flex;
    flex-direction: column;
}
.feature {
    display: flex;
    align-items: center;
    gap: 0.5em;

    i {
        font-size: 1.125em;
        color: var(--carbon-600);
    }

    div {
        flex: 1;
    }
}

.basic-features {
    font-size: 0.875em;
    line-height: 1.35;
    margin-bottom: 0;
}

.premium-feature-text {
    font-weight: 600;
    font-size: 0.875em;
    line-height: 1.35;
    margin-bottom: 2px;
}

.premium-feature-supporting-text {
    font-size: 0.875em;
    line-height: 1.35;
    margin-bottom: 0;
    color: var(--carbon-600);
}
</style>